var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }